import { FeedbackStatus } from '@/models/feedback.model';

export enum FeedbacksFiltersFields {
  NAME = 'name',
  PHONE = 'phone',
  STATUS = 'status',
  COMMENT = 'comment',
  EMAIL = 'email',
  DATE_FROM = 'date_from',
  DATE_TO = 'date_to',
  MODEL_NAME = 'model_name',
  MODEL_ID = 'model_id',
  TITLE = 'title',
  TAX_CODE = 'organization_tax_code',
  MANAGER_ID = 'manager_id',
}

export type TGetFeedbacksQuery = {
  [FeedbacksFiltersFields.STATUS]?: FeedbackStatus;
  [FeedbacksFiltersFields.COMMENT]?: string;
  [FeedbacksFiltersFields.PHONE]?: string;
  [FeedbacksFiltersFields.EMAIL]?: string;
  [FeedbacksFiltersFields.NAME]?: string;
  [FeedbacksFiltersFields.DATE_FROM]?: string;
  [FeedbacksFiltersFields.DATE_TO]?: string;
  [FeedbacksFiltersFields.MODEL_ID]?: string;
  [FeedbacksFiltersFields.MODEL_NAME]?: string;
  [FeedbacksFiltersFields.TITLE]?: string;
  [FeedbacksFiltersFields.TAX_CODE]?: string;
  [FeedbacksFiltersFields.MANAGER_ID]?: string;
};
